module.exports = __webpack_public_path__ + "img/dstv.06f8a206.png";